// Green theme
const green = {
  id: 'green',
  name: 'Vihreä',
  price: 25,
  main: '#388e3c',
  light: '#66bb6a',
  dark: '#2e7d32',
  bg: '#e8f5e9',
  darkBg: '#1a2d1a',
  isSuper: false,
  surfaces: {
    // Light mode
    lightBg: '#c8e6c9',
    lightPaper: '#e8f5e9',
    lightContainer: '#e8f5e9',
    lightOnSurface: '#1a2e1a',
    lightOnSurfaceVariant: '#3d5e3e',
    lightOutline: '#5ea05e',
    // Dark mode
    containerLowest: '#122512',
    containerLow: '#071007',
    container: '#122512',
    containerHigh: '#264026',
    containerHighest: '#2e4c2e',
    bright: '#385838',
    onSurface: '#d8f5d8',
    onSurfaceVariant: '#9ad49a',
    outline: '#5ea05e',
    outlineVariant: '#365e36',
    // Button colors — primary
    primaryContainer: '#66bb6a',
    onPrimaryContainer: '#002e04',
    // Button colors — secondary (outlined)
    secondaryContainer: '#1a3a1a',
    onSecondaryContainer: '#90d494',
    // Button colors — secondary (filled)
    secondary: '#a5d6a7',
    onSecondary: '#1b5e20',
    secondaryLight: '#2e7d32',
    onSecondaryLight: '#ffffff',
    // Button colors — inverse
    inverseSurface: '#e8f5e9',
    onInverseSurface: '#1a2d1a',
    inverseSurfaceLight: '#1a2d1a',
    onInverseSurfaceLight: '#d8f5d8',
    // Button colors — label/text
    labelColor: '#66bb6a',
    labelColorLight: '#2e7d32',
    // Status colors
    success: '#4caf50',
    successLight: '#81c784',
    successDark: '#2e7d32',
    warning: '#ed6c02',
    warningLight: '#ff9800',
    warningDark: '#e65100',
    error: '#ef5350',
    errorLight: '#ff7961',
    errorDark: '#c62828',
  },
};

export default green;
